import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { ToasterModule } from 'angular2-toaster';
import { CalendarModule } from 'ap-angular2-fullcalendar';
import { MyDatePickerModule } from 'mydatepicker';
import { ModalModule } from 'ngx-modal';
import { ScheduleModule } from 'primeng/primeng';
import { DragDropDirectiveModule } from "angular4-drag-drop";

import { ChartModule } from 'angular2-highcharts';
import * as highcharts from 'highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';

import { routes } from './app.routes';

import { AppComponent } from './app.component';
import { AppGuard } from './app.guard';
import { ChannelsComponent } from './channels/channels.component';
import { CompaniesComponent } from './companies/companies.component';
import { CompanyComponent } from './company/company.component';
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { MediaComponent } from './media/media.component';
import { PlaylistComponent } from './playlist/playlist.component';
import { SidebarComponent } from './sidebar/sidebar.component';

import { CompanyService }                     from './company.service';
import { UserInfoService }                    from './shared/user-info.service';
import { DevicesConfirmedUnconfirmedService } from './devices-confirmed-unconfirmed.service';


import { UsersComponent } from './users/users.component';

import { SafeHtmlPipe } from './safeHtmlPipe';
import { SafePipe } from './safePipe';

import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { CalendarPreviewComponent } from './calendar/calendar.component';
import { DeviceEditComponent } from './device-edit/device-edit.component';
import { DevicesComponent } from './devices/devices.component';
import { PlaylistEditComponent } from './playlist-edit/playlist-edit.component';
import { PlaylistSlideshowComponent } from './playlist-slideshow/playlist-slideshow.component';
import { HelpComponent } from './help/help.component';
import { PlaylistTableComponent } from './playlist-table/playlist-table.component';
import { DevicesTableComponent } from "./devices-table/devices-table.component";
import { ActiveDatesModalComponent } from './active-dates-modal/active-dates-modal.component';
import { DoubleScrollComponent } from './double-scroll.component/double-scroll.component';
import { OwnersComponent } from './owners/owners.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Http, HttpModule } from '@angular/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AdminComponent } from './admin/admin.component';
import { PlaylistEditResolveService } from './playlist-edit/playlist-edit-resolve.service';
import { NewsComponent } from './news/news.component';
import { BusComponent } from './bus/bus.component';
import { BlockUIModule } from 'ng-block-ui';
import { EinkdevicesComponent } from './einkdevices/einkdevices.component';

export function highchartsFactory() {
      const hc = require('highcharts');
      const dd = require('highcharts/modules/drilldown');
      dd(hc);

      return hc;
}

export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    SafePipe,
    SafeHtmlPipe,
    AppComponent,
    LoginComponent,
    CompaniesComponent,
    HeaderComponent,
    SidebarComponent,
    ChannelsComponent,
    CompanyComponent,
    MediaComponent,
    PlaylistComponent,
    UsersComponent,
    PlaylistEditComponent,
    PlaylistSlideshowComponent,
    DeviceEditComponent,
    DevicesComponent,
    CalendarPreviewComponent,
    HelpComponent,
    PlaylistTableComponent,
    DevicesTableComponent,
    ActiveDatesModalComponent,
    DoubleScrollComponent,
    OwnersComponent,
    AdminComponent,
    NewsComponent,
    BusComponent,
    EinkdevicesComponent,
  ],
  imports: [
    AngularMultiSelectModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ModalModule,
    MyDatePickerModule,
    NguiAutoCompleteModule,
    RouterModule.forRoot(routes),
    TimepickerModule.forRoot(),
    ToasterModule,
    CalendarModule,
    ScheduleModule,
    DragDropDirectiveModule,
    ChartModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http]
      }
    }),
    BlockUIModule
  ],
  providers: [
     AppGuard,
     CompanyService,
     DevicesConfirmedUnconfirmedService,
     UserInfoService,
     {
       provide: HighchartsStatic,
       useFactory: highchartsFactory
     },
    PlaylistEditResolveService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/app.module.ts